import React, { Component } from 'react';
import Filter from './Filter';
import List from './List';

class TablePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            load: null,
        };
    }
    
    search = () => {
        this.setState({ load: {} });
    }

    render() {
        const { searchParams, businessList, clientHeight, onChange } = this.props;
        const { load } = this.state;
        const height = clientHeight - 72 - 94 - 45 - 60;

        return (
            <div className="pane-item-content">
                <Filter
                    search={this.search}
                    searchParams={searchParams}
                    businessList={businessList}
                    onChange={onChange}
                />
                <List
                    load={load}
                    height={height}
                    searchParams={searchParams}
                />
            </div>
        );
    }
}

export default TablePage;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/ClientDataSearch/ClientDataSearchSheet/TablePage/index.js